import React from 'react'
import IconBase from 'components/atoms/IconBase/IconBase'

interface Props {
  idVariant?: string
  className?: string
}

function Zoom({ idVariant = '', className }: Props) {
  return (
    <IconBase name="zoom" w={24} className={className}>
      <circle cx="11" cy="11" r="6.5" stroke="currentColor"/>
      <path d="M16 16L20 20" stroke="currentColor"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M11.5 7.5H10.5V10.5H7.5V11.5H10.5V14.5H11.5V11.5H14.5V10.5H11.5V7.5Z" fill="currentColor"/>
    </IconBase>
  )
}

export default Zoom
